import { render, staticRenderFns } from "./CAlert.vue?vue&type=template&id=b4159a90&scoped=true"
import script from "./CAlert.vue?vue&type=script&setup=true&lang=ts"
export * from "./CAlert.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CAlert.vue?vue&type=style&index=0&id=b4159a90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4159a90",
  null
  
)

export default component.exports